import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {MicroSelectComponent} from "../shared/select/micro-select.component";
import {MicroPicklistComponent} from "../shared/picklist/micro-picklist.component";

@Component({
  selector: 'micro-itsmObject-picklist',
  templateUrl: './itsmObject-picklist.component.html'
})
export class ItsmObjectPicklistComponent implements OnChanges  {
  all:any[];
  description:any;

  @Input()
  type:any;

  @Output()
  selectedItemsChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  selectedItems:string[];

  @ViewChild("picklist", {static: true}) sel:MicroPicklistComponent;

  onNgModelChange(e) {
    this.selectedItemsChange.emit(e);
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  public getSelected() {
    return this.sel.getSelected();
  }

  reload() {
    if (!this.type) {
      return;
    }

    let params:HttpParams = new HttpParams()
      .set('itsmObjectType', this.type)
    ;
    return this.http.get(`${this.env.e.url}/task/itsmObjects/all`, {params:params})
      .subscribe(data => {
        this.all = data as any[];
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'type') {
        this.reload();
      }
    }
  }
}
